import { FEATURES } from "@/config/featureFlags";
import { useAuth } from "@/features/auth/auth";

export function useEquipmentVisible() {
  const { user } = useAuth();
  return FEATURES.equipment && (FEATURES.equipmentForAgents || (!!user && user.role !== "USER"));
}
